// 过滤格式，移动端集联选择
export function expandSelectedValues(selected: {
  mainFunctions: string[],
  jobFunctions: string[],
  functionTitles: string[]
}, options: any[]) {
  const result = new Set<any>(); // 改为存储整个对象

  // 添加已选的 functionTitles
  selected.functionTitles.forEach(titleValue => {
    options.forEach(mainFunction => {
      mainFunction.children?.forEach(jobFunction => {
        jobFunction.children?.forEach(title => {
          if (title.value === titleValue) {
            result.add(title);
          }
        });
      });
    });
  });

  // 展开 jobFunctions
  selected.jobFunctions.forEach(jobFunctionValue => {
    options.forEach(mainFunction => {
      const jobFunction = mainFunction.children?.find(
        job => job.value === jobFunctionValue
      );
      if (jobFunction) {
        jobFunction.children?.forEach(title => {
          result.add(title);
        });
      }
    });
  });

  // 展开 mainFunctions
  selected.mainFunctions.forEach(mainFunctionValue => {
    const mainFunction = options.find(main => main.value === mainFunctionValue);
    if (mainFunction) {
      mainFunction.children?.forEach(jobFunction => {
        jobFunction.children?.forEach(title => {
          result.add(title);
        });
      });
    }
  });

  return Array.from(result);
}

// 还原格式移动端
export function restoreOriginalObjectMobile(values, options) {
  const originalObject = {
    mainFunctions: new Set(),
    jobFunctions: new Set(), // 使用 Set 来确保唯一性
    functionTitles: new Set(),
  };

  const selectedValues = new Set(values.map(item => item.value));

  // 处理每个顶层选项
  options.forEach(mainFunction => {
    const jobFunctions = mainFunction.children || [];

    jobFunctions.forEach(jobFunction => {
      const functionTitles = jobFunction.children || [];
      // 检查是否所有子项都被选中
      const allTitlesSelected = functionTitles.every(title =>
        selectedValues.has(title.value)
      );

      if (allTitlesSelected) {
        // 如果所有子项都被选中，则选择父级
        originalObject.jobFunctions.add(jobFunction.value);
      } else {
        // 否则添加已选中的子项
        functionTitles.forEach(title => {
          if (selectedValues.has(title.value)) {
            originalObject.functionTitles.add(title.value);
          }
        });
      }
    });

    // 检查是否所有职能都被选中
    const allJobFunctionsSelected = jobFunctions.every(jobFunction =>
      originalObject.jobFunctions.has(jobFunction.value)
    );

    if (allJobFunctionsSelected) {
      // 如果所有职能都被选中，则选择主要职能
      originalObject.mainFunctions.add(mainFunction.value);
      originalObject.jobFunctions.clear(); // 清除子级选择
    }
  });

  return {
    mainFunctions: Array.from(originalObject.mainFunctions),
    jobFunctions: Array.from(originalObject.jobFunctions),
    functionTitles: Array.from(originalObject.functionTitles)
  };
}
